// extracted by mini-css-extract-plugin
module.exports = {"name":"NavigationBar_name__3XGtg","search":"NavigationBar_search__ZDzZ-"};